const BWButtons = [
    {
      "id": "think5whys",
      "text": "Think5Whys",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'think5whys')"
    },
    {
      "id": "collections",
      "text": "Collections",
      "backgroundColor": "#ffff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'collections')"
    },
    {
      "id": "mindspark",
      "text": "MindSpark",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'mindspark')"
    },
    {
      "id": "academics",
      "text": "Academics",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'academics')"
    },
    {
      "id": "children",
      "text": "Children",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'children')"
    },
    {
      "id": "professional",
      "text": "Professional",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'professional')"
    },
    {
        "id": "competition",
        "text": "Competition",
        "backgroundColor": "#00ff00",
        "color": "#333",
        "hoverBackgroundColor": "#666",
        "hoverColor": "#fff",
        "onClick": "setSearch('t', 'competition')"
    },
    {
        "id": "stem",
        "text": "STEM",
        "backgroundColor": "#00ff00",
        "color": "#333",
        "hoverBackgroundColor": "#666",
        "hoverColor": "#fff",
        "onClick": "setSearch('t', 'stem')"
    },
    {
        "id": "arts",
        "text": "Arts",
        "backgroundColor": "#00ff00",
        "color": "#333",
        "hoverBackgroundColor": "#666",
        "hoverColor": "#fff",
        "onClick": "setSearch('t', 'arts')"
    },
    {
        "id": "commerce",
        "text": "Commerce",
        "backgroundColor": "#00ff00",
        "color": "#333",
        "hoverBackgroundColor": "#666",
        "hoverColor": "#fff",
        "onClick": "setSearch('t', 'commerce')"
    },
    {
        "id": "law",
        "text": "Law",
        "backgroundColor": "#00ff00",
        "color": "#333",
        "hoverBackgroundColor": "#666",
        "hoverColor": "#fff",
        "onClick": "setSearch('t', 'law')"
    },
    {
        "id": "lifescience",
        "text": "LifeScience",
        "backgroundColor": "#00ff00",
        "color": "#333",
        "hoverBackgroundColor": "#666",
        "hoverColor": "#fff",
        "onClick": "setSearch('t', 'lifescience')"
    },
    {
      "id": "msmemonthly",
      "text": "MSMEMonthly",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'msmemonthly')"
    },
    {
      "id": "bookclub",
      "text": "Book Club",
      "backgroundColor": "#ffff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "navigate('/bookclub-home')"
    },
    {
      "id": "program",
      "text": "Program",
      "backgroundColor": "#f5a9f5",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'program')"
    },
    {
      "id": "courses",
      "text": "Courses",
      "backgroundColor": "#f5a9f5",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'courses')"
    },
    {
      "id": "publishers",
      "text": "Publishers",
      "backgroundColor": "#f5a9f5",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'publishers')"
    },
    {
      "id": "institutional",
      "text": "Institutional",
      "backgroundColor": "#f5a9f5",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'institutional')"
    },
    {
      "id": "youngadults",
      "text": "Young Adults",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'youngadults')"
    },
    {
      "id": "mature",
      "text": "Mature",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'mature')"
    },
    {
      "id": "recreational",
      "text": "Re-Creational",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'recreational')"
    },
    {
      "id": "fiction",
      "text": "Fiction",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'fiction')"
    },
    {
      "id": "nonfiction",
      "text": "Non-Fiction",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'nonfiction')"
    },
    {
      "id": "cdr",
      "text": "CDR",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'cdr')"
    },
    {
      "id": "madsmania",
      "text": "MADSmania",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'madsmania')"
    },
    {
      "id": "purplepower",
      "text": "PurplePower",
      "backgroundColor": "#00ff00",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('t', 'purplepower')"
    },
    {
      "id": "imagebooks",
      "text": "Picture Books",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'picture')"
    },
    {
      "id": "audiobooks",
      "text": "Audio Books",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'audio')"
    },
    {
      "id": "videobooks",
      "text": "Video Books",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'video')"
    },
    {
      "id": "flipbooks",
      "text": "Flip Books",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'flip')"
    },
    {
      "id": "tvbooks",
      "text": "TV Books",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'tv')"
    },
    {
      "id": "arbooks",
      "text": "AR Books",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'ar')"
    },
    {
      "id": "printedbooks",
      "text": "Printed Books",
      "backgroundColor": "#f5a9f5",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "navigate('/orderflow-home')"
    },
    {
      "id": "secondhandbooks",
      "text": "Used Books",
      "backgroundColor": "#f5a9f5",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "navigate('/orderflow-home')"
    },
    {
      "id": "bestsellers",
      "text": "Best Sellers",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'bestsellers')"
    },
    {
      "id": "free",
      "text": "Free",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'free')"
    },
    {
      "id": "suggested",
      "text": "Suggested",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'suggested')"
    },
    {
      "id": "upcoming",
      "text": "Upcoming",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'upcoming')"
    },
    {
      "id": "bestsellingauthors",
      "text": "Best Selling Authors",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'bestsellingauthors')"
    },
    {
      "id": "newauthors",
      "text": "New Authors",
      "backgroundColor": "#18eded",
      "color": "#333",
      "hoverBackgroundColor": "#666",
      "hoverColor": "#fff",
      "onClick": "setSearch('f', 'newauthors')"
    }
  ];

  export default BWButtons;